export const contactSupport = {
  support_title_message: "联系我们，我们一起解决！",
  support_message: "如果您需要帮助或有任何疑问，我们的团队随时准备为您提供帮助",
  support_modal_email: "邮箱",
};
